import styles from "./LabelledToggle.module.css";
import { BaseToggle, BaseLabel } from "@/entities";
import { BaseToggleProps } from "../../atoms/BaseToggle";

type LabelledToggleProps = {
  /**
   * Text for the label.
   */
  label: string;
} & BaseToggleProps;

/**
 * Labelled checkbox.
 */
export function LabelledToggle({ label, ...rest }: LabelledToggleProps) {
  return (
    <div className={styles.root} data-testid={LabelledToggle.displayName}>
      <BaseLabel as="span">{label}</BaseLabel>
      <BaseToggle {...rest} />
    </div>
  );
}
LabelledToggle.displayName = "LabelledToggle";
